import { updateBookingSMS } from '../../../store/Bookings/actions';
import Image from 'next/image';
import {
  HiMailOpen,
  HiOfficeBuilding,
  HiOutlineUser,
  HiPencilAlt,
  HiPhone,
} from 'react-icons/hi';
import { useDispatch } from 'react-redux';

export default function ContactDetails({ booking }) {
  const dispatch = useDispatch();

  return (
    <>
      <div className="mt-2">
        <div className="flex items-center">
          <input
            id="remember"
            name="remember"
            type="checkbox"
            className={`h-4 w-4 rounded border-gray-300`}
            style={{
              accentColor: booking.branch.branch_colour,
              outline: `2px solid ${booking.branch.branch_colour}`,
            }}
            checked={booking.sms == 1 ? true : false}
            onChange={() => {
              dispatch(
                updateBookingSMS(booking.branch.id, booking, !booking.sms)
              );
            }}
          />
          <label htmlFor="remember" className="ml-2 block text-gray-700">
            Send SMS updates
          </label>
        </div>
      </div>

      <div className="mt-5">
        <h5 className="font-medium">Order Number</h5>
      </div>
      <div className="text-sm">{booking.order_number ?? 'No order number'}</div>
      <div className="my-5 grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="cursor-pointer">
          <div className="flex flex-row items-center justify-between">
            <div>
              <h5 className="font-medium">Booked for</h5>
            </div>
          </div>
          <div>
            <div className="my-2 flex">
              <HiOfficeBuilding
                className={`mr-3 h-[21px] w-[20px] flex-none`}
                style={{
                  color: booking.branch.branch_colour,
                }}
              />

              <div className="text-sm">{booking.company_name ?? '-'}</div>
            </div>
            <div className="my-2 flex">
              <HiOutlineUser
                className={`mr-3 h-[21px] w-[20px] flex-none`}
                style={{
                  color: booking.branch.branch_colour,
                }}
              />
              <div className="text-sm">
                {booking.delivery_location.name ?? '-'}
              </div>
            </div>
            <div className="my-2 flex">
              <HiPhone
                className={`mr-3 h-[21px] w-[20px] flex-none`}
                style={{
                  color: booking.branch.branch_colour,
                }}
              />
              <div className="text-sm">
                {booking.delivery_location.phone ?? '-'}
              </div>
            </div>
            <div className="my-2 flex">
              <HiMailOpen
                className={`mr-3 h-[21px] w-[20px] flex-none`}
                style={{
                  color: booking.branch.branch_colour,
                }}
              />
              <div className="text-sm">
                {booking.delivery_location.email ?? '-'}
              </div>
            </div>
            <div className="my-2 flex">
              <HiPencilAlt
                className={`mr-3 h-[21px] w-[20px] flex-none`}
                style={{
                  color: booking.branch.branch_colour,
                }}
              />
              <div className="text-sm">{booking.internal_notes ?? '-'}</div>
            </div>
          </div>
        </div>

        <div className="col-span-2 pl-0 md:pl-5">
          {booking.photo ? (
            // eslint-disable-next-line @next/next/no-img-element
            <img
              src={booking.photo}
              width={200}
              alt="delivery photo"
              height={200}
            />
          ) : (
            <span className="block w-full text-center">
              No image to display
            </span>
          )}
        </div>
      </div>
    </>
  );
}
